import React, { useState, useEffect } from 'react';
import { StyledCheckboxColorTile, StyledColorNameLabel, StyledCountLabel, } from '../styles/CheckboxColorTile.styles';
import { formatCount } from '../../../utils';
import { useServicesContext } from '../../../context';
import { useApplyFilters } from '../FilterContextHooks';
import { FilterContext } from '../FilterContext';
import { useI18n } from '@oneaudi/i18n-context';
const availableColorTiles = {
    exterior: [
        'beige',
        'black',
        'blue',
        'bronze',
        'brown',
        'default',
        'gold',
        'gray',
        'green',
        'orange',
        'red',
        'silver',
        'violet',
        'white',
        'yellow',
    ],
    interior: [
        'beige',
        'black',
        'blue',
        'brown',
        'default',
        'gray',
        'green',
        'red',
        'silver',
        'white',
        'yellow',
    ],
};
export const CheckboxColorTile = ({ groupHeadline, filterCategory, itemHeadline, itemText, visibleIn, color, isPlpQuickFilters, }) => {
    const checkboxColorTileTextKey = useI18n({
        id: `nemo.sc.filter.filtergroups.${groupHeadline}.ariaLabel`,
        defaultMessage: 'Select Color {{color}}',
    });
    const checkboxColorTileAriaLabel = checkboxColorTileTextKey === null || checkboxColorTileTextKey === void 0 ? void 0 : checkboxColorTileTextKey.replace('{{color}}', itemText);
    const applyFilters = useApplyFilters();
    const context = React.useContext(FilterContext);
    const [active, setActive] = useState(false);
    const [count, setCount] = useState();
    const isDisabled = count <= 0;
    const [isChecked, setIsChecked] = useState(false);
    const handleChange = () => {
        const filterDTO = {
            id: itemHeadline,
            active: !isChecked,
        };
        const currentFilter = { id: itemHeadline, values: [] };
        const componentName = isPlpQuickFilters ? 'vtp quick filter' : 'vtp filter';
        const trackingEventName = !isChecked
            ? `${componentName} - add filter`
            : `${componentName} - remove filter`;
        const trackingData = {
            trackingEventName,
            trackingLabel: itemText,
            trackingValue: filterCategory,
            changedFilter: [currentFilter],
        };
        setIsChecked(!isChecked);
        applyFilters(filterDTO, trackingData);
    };
    useEffect(() => {
        const checkboxFiltersData = context.filterData.groups;
        const checkboxFilterData = checkboxFiltersData[groupHeadline].members[itemHeadline];
        setActive(checkboxFilterData.active);
        setCount(checkboxFilterData.count);
    }, [context]);
    useEffect(() => {
        setIsChecked(active);
    }, [active]);
    const { colorType, colorName } = color;
    const accessibleLabel = `${itemText} ${colorName}`;
    const isColorTileAvailableForThisColor = availableColorTiles[colorType].includes(colorName);
    const { featureAppConfig } = useServicesContext();
    const localeService = useServicesContext().getAdditionalService('gfa:locale-service');
    const { assetUrl } = featureAppConfig;
    const locale = `${localeService.language}-${localeService.countryCode}`;
    const assetBaseUrl = assetUrl;
    const colorUrl = isColorTileAvailableForThisColor
        ? `${assetBaseUrl}/img/colortiles/${colorType}-color.${colorName}.png`
        : `${assetBaseUrl}/img/colortiles/fallback.png`;
    return (React.createElement(StyledCheckboxColorTile, { id: `checkbox${itemHeadline}_${visibleIn}`, checked: isChecked, disabled: isDisabled, onChange: handleChange, value: `checkbox${itemHeadline}_${visibleIn}`, name: `checkbox${itemHeadline}_${visibleIn}`, colorUrl: colorUrl, isPlpQuickFilters: isPlpQuickFilters, "aria-label": checkboxColorTileAriaLabel, "aria-checked": isChecked, alt: `${accessibleLabel} color selection tile`, label: !isPlpQuickFilters && (React.createElement(React.Fragment, null,
            React.createElement(StyledColorNameLabel, null, itemText),
            ' ',
            React.createElement(StyledCountLabel, null,
                "(",
                formatCount(count, locale).toString(),
                ")"))) }));
};
